import { render, staticRenderFns } from "./DashboardDoctorHis.vue?vue&type=template&id=3ce6c40a&scoped=true"
import script from "./DashboardDoctorHis.vue?vue&type=script&lang=js"
export * from "./DashboardDoctorHis.vue?vue&type=script&lang=js"
import style0 from "./DashboardDoctorHis.vue?vue&type=style&index=0&id=3ce6c40a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce6c40a",
  null
  
)

export default component.exports